import { GlassCard } from '@/components/design/GlassCard';
import { LucideIcon, ArrowUpRight, ArrowDownRight } from 'lucide-react';

interface StatsCardProps {
  title: string;
  value: string;
  change: string;
  trend: 'up' | 'down' | 'neutral';
  icon: LucideIcon;
  color: string; // Tailwind color class mostly for text/bg
}

export const StatsCard = ({ title, value, change, trend, icon: Icon, color }: StatsCardProps) => {
  return (
    <GlassCard hoverEffect className="relative overflow-hidden group">
      <div className={`absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity ${color}`}>
        <Icon className="w-24 h-24 -mr-8 -mt-8" />
      </div>

      <div className="relative z-10 flex justify-between items-start mb-4">
        <div className={`p-3 rounded-xl bg-white/5 ${color}`}>
          <Icon className="w-6 h-6" />
        </div>
        <div className={`flex items-center gap-1 text-sm font-medium px-2 py-1 rounded-full bg-white/5 ${
          trend === 'up' ? 'text-green-400' : trend === 'down' ? 'text-red-400' : 'text-gray-400'
        }`}>
          {trend === 'up' ? <ArrowUpRight className="w-3 h-3" /> : <ArrowDownRight className="w-3 h-3" />}
          {change}
        </div>
      </div>

      <div className="relative z-10">
        <h3 className="text-muted-foreground text-sm font-medium mb-1">{title}</h3>
        <div className="text-3xl font-bold tracking-tight">{value}</div>
      </div>
      
      {/* Decorative pulse */}
      <div className="absolute -bottom-4 -left-4 w-24 h-24 bg-primary/20 rounded-full blur-3xl group-hover:bg-primary/30 transition-colors" />
    </GlassCard>
  );
};
